import { FC } from 'react';
import { useToast } from '@chakra-ui/react';
import {
  useCheckSignDocumentMutation,
  useFetchProfileQuery,
  useRequestDocumentSignMutation,
} from 'rtkQuery/sharespro/queries/profile';

import { useTranslation } from 'react-i18next';
import PhoneConfirmationModal from 'presentation/components/shared/modals/PhoneConfirmationModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  documentId: ID;
  onSuccess: () => void;
}

const DocumentSignModal: FC<Props> = ({ isOpen, onClose, documentId, onSuccess }) => {
  const { data } = useFetchProfileQuery();

  const [verifyOtp, { isLoading }] = useCheckSignDocumentMutation();

  const toast = useToast();

  const { t } = useTranslation();

  const [requestDocumentSign, { isLoading: newCodeRequesting }] =
    useRequestDocumentSignMutation();

  return (<PhoneConfirmationModal
    isOpen={isOpen}
    onClose={onClose}
    title={t('signDocSms')}
    text={t('codeHasBeenSendToNumberDocument')}
    phoneNumber={data?.phone ?? null}
    onSubmit={async (values) => {
      await verifyOtp({
        otpId: values.otpId as number,
        code: parseInt(values.code),
      })
        .unwrap()
        .then(() => {
          onClose();
          toast({
            description: t('orderConfirmed'),
            status: 'success',
            position: 'top-right',
            isClosable: true,
          });
        });
      onSuccess();
    }}
    otpVerifying={isLoading}
    onSendNewCode={async () => {
      return await requestDocumentSign(documentId).unwrap();
    }}
    newCodeRequesting={newCodeRequesting}
  />);
};

export default DocumentSignModal;
